import { Eligibility } from "./types"

// Ids only: customer names / phones from the payload are never read.
export const isCustomerEligible = (discount: { eligibility: Eligibility }, customerId: number | null): boolean => {
	const { eligibility } = discount
	switch (eligibility.type) {
		case "FOR_ALL":
			return true
		case "CUSTOMERS":
			return customerId != null && eligibility.customerIds.includes(customerId)
		case "CUSTOMER_GROUP":
			return customerId != null && eligibility.groups.some((group) => group.customerIds.includes(customerId))
		default:
			return false
	}
}

export const isWithinDates = (discount: { startsAt: number | null, endsAt: number | null }, now: number): boolean =>
	(discount.startsAt == null || now >= discount.startsAt) && (discount.endsAt == null || now <= discount.endsAt)
